import { connect } from 'react-redux';
import CRUDAction from '../../../actions/participant';
import ParticipantsEditForm from '../ParticipantsEditForm'
import LoadingContainer from '../../LoadingContainer';

export default connect(
  ({ participant: { loadingItem }}) => ({
    loading: loadingItem,
    childrenComponent: ParticipantsEditForm,
    childrenProps: {
      title: 'Edit participant'
    }
  }),
  dispatch => ({
    init: ({ params: { id }}) => dispatch(CRUDAction.fetch(id))
  })
)(LoadingContainer);





// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsEdit/index.js